<template>
  <div>
    <b-row v-if="!isLoading" class="justify-content-center flex-column">
      <div
        v-if="building.building_owners.length == 0 && votingCategories.length == 0"
        class="text-center font-18"
      >
        {{ "Aucune catégorie de vote, veuillez en ajouter une à l'étape 5 !" }}
      </div>
      <div v-else class="text-center font-18">
        {{ "Veuillez sélectionner une charge générale dans la liste suivante" }}
      </div>
      <ValidationProvider
        ref="building-step-7-charges-generales"
        v-slot="{ errors, classes }"
        class="text-center d-flex mt-5 flex-column align-items-center"
        :name="'charge générales'"
        rules="required"
      >
        <span class="text-center mb-3" :class="classes">{{ errors[0] }}</span>
        <b-table
          v-if="votingCategories.length > 0"
          ref="checkbox-table"
          class="agv-table td-middle w-50"
          bordered
          :items="votingCategories"
          :fields="fields"
        >
          <template v-slot:cell(name)="row">
            <div class="text-left">
              <appTextArea
                :ref="'name-' + row.item.id"
                :text="row.item.name"
                :property="'name'"
                :item-id="row.item.id"
                class="min-w-130"
                @update="updateProperty"
              ></appTextArea>
            </div>
          </template>
          <template v-slot:cell(is_charge_general)="row">
            <b-form-radio-group
              v-model="selectedVotingCategoryId"
              stacked
              class="custom-radio-checkbox"
              @change="changedCheckbox"
            >
              <b-form-radio :key="row.item.id" class="my-2 font-16" :value="row.item.id" size="lg">
              </b-form-radio>
            </b-form-radio-group>
          </template>
          <template v-slot:cell(_actions)="row">
            <b-row class="actions text-center">
              <b-col>
                <b-button
                  v-if="row.item.building_owner_voting_rights.length == 0"
                  size="sm"
                  title="Supprimer la charge générale"
                  class="tablebutton btn-red"
                  @click="deleteVotingCategory(row.item)"
                >
                  <font-awesome-icon icon="trash-alt" size="1x" />
                </b-button>
              </b-col>
            </b-row>
          </template>
        </b-table>
      </ValidationProvider>
    </b-row>
    <appLoader v-if="isLoading" />
  </div>
</template>

<script>
import VotingCategoryMW from "@/middlewares/VotingCategory";
import VotingCategoryORM from "@/store/orm-axios/models/VotingCategory";
export default {
  components: {
    appTextArea: () => import("@/components/b-table-components/TextArea"),
  },
  props: {
    building: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      legal: "",
      legalMentions: "",
      isLoading: true,
      selectedVotingCategoryId: null,
      fields: [
        {
          key: "name",
          label: "Nom",
        },
        {
          key: "is_charge_general",
          label: "Charge générale",
        },
        {
          key: "_actions",
          label: "Actions",
        },
      ],
    };
  },
  computed: {
    votingCategories() {
      return VotingCategoryORM.query()
        .where("building_id", this.building.id)
        .withAllRecursive(2)
        .get();
    },
    hasChargeGeneral() {
      return VotingCategoryORM.query()
        .where("building_id", this.building.id)
        .where("is_charge_generale", 1)
        .first();
    },
  },
  async created() {
    await VotingCategoryMW.FETCH(this.building.id).then(() => {
      if (this.hasChargeGeneral) {
        this.selectedVotingCategoryId = this.hasChargeGeneral.id;
      }
      this.isLoading = false;
    });
  },
  methods: {
    changedCheckbox(e) {
      this.$emit("updateVotingCategory");
      let votingCategory = this.$_.find(this.votingCategories, item => {
        return item.id == e;
      });
      if (votingCategory) {
        votingCategory.is_charge_generale = 1;
        this.updateVotingCategory(votingCategory);
      }
    },
    async updateVotingCategory(votingCategory) {
      await VotingCategoryMW.PUT(votingCategory)
        .then(() => {})
        .catch(err => {
          console.log("err", err);
        });
    },
    async updateProperty(e) {
      let votingCategory = this.$_.find(this.votingCategories, item => {
        return item.id == e.itemId;
      });
      if (votingCategory) {
        votingCategory[e.property] = e.value;
        this.updateVotingCategory(votingCategory);
      }
    },
    deleteVotingCategory(votingCategory) {
      console.log(votingCategory);
      var self = this;
      self
        .$swal(self.alertQuestion())
        .then(res => {
          if (res.value) {
            VotingCategoryMW.CUSTOM_DELETE(votingCategory.id)
              .then(() => {
                this.$emit("updateVotingCategory", false);
              })
              .catch(err => {
                self.$swal(self.alertError());
              });
          } else {
            // Cancel
          }
        })
        .catch(err => {
          self.$swal(self.alertError());
        });
    },
  },
};
</script>
